import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {StyledJournalEntryTabContainer} from '../../../NetSuiteJournalEntriesPage/JournalEntriesTabs/StyledJournalEntriesTabs';
import TableFilters from '../../TableFilters';
import EmptyOrTable from '../../../../EmptyOrTable';
import {accountingHelpers} from '../../../../../utils/helpers';

const dateColumnProps = accountingHelpers.getDateColumnProps();

const ErpBillsTab = ({
  data = [],
  empty,
  loading = false,
  onFilter,
  onRowUpdate,
  tableFiltersProps,
  tableProps,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [query, setQuery] = useState({ search: '' });

  const handleOnFilter = (filterParams) => {
    setQuery({...query, ...filterParams});
    onFilter?.(filterParams);
  }

  const columns = [
    { dataIndex: 'remote_id', title: t('billReference') },
    {
      ...dateColumnProps,
      dataIndex: 'invoice_date',
      title: `${t('invoice')} ${t('date')}`,
      render: (_, invoice) => accountingHelpers.getBillInvoiceDateWithLink({invoice, t}),
    },
    {
      dataIndex: 'id',
      title: t('invoice'),
      render: (value) => accountingHelpers.renderInvoicePreview(value, 'accounting')
    },
    {
      align: 'right',
      dataIndex: 'amount',
      render: accountingHelpers.getBillAmount,
      title: t('amount'),
    },
  ];

  return (
    <StyledJournalEntryTabContainer
      {...rest}
      size='large'
      direction='vertical'
    >
      <TableFilters
        {...tableFiltersProps}
        dateFilterName='transaction_date'
        filterFields={['search', 'daterange']}
        onFilter={handleOnFilter}
      />
      <EmptyOrTable
        data={data}
        empty={empty}
        loading={loading}
        query={query}
        columns={columns}
        tableProps={tableProps}
      />
    </StyledJournalEntryTabContainer>
  );
}

ErpBillsTab.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  empty: PropTypes.any,
  loading: PropTypes.bool,
  onFilter: PropTypes.func,
  tableFiltersProps: PropTypes.any,
  tableProps: PropTypes.object,
}

export default ErpBillsTab;
